import { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import * as func from "../common/manipurCommon/FunctionCalls";

const AuthManager = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const publicPaths = ["/manipur/login"];
  const isPublicPath = publicPaths.includes(currentPath);
  const roleType = "/manipur/login";

  const accessTime = parseInt(localStorage.getItem("accessConfigValue") || "60", 10);
  const logoutTimeSeconds = parseInt(localStorage.getItem("closeConfigValue") || "60", 10);
  const refreshTimeSeconds = parseInt(localStorage.getItem("refreshConfigValue") || "60", 10);

  const logoutTime = logoutTimeSeconds * 1000;
  const refreshInterval = refreshTimeSeconds * 1000;

  const activityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const refreshTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isUserActiveRef = useRef<boolean>(true);

  const refreshToken = async () => {
    try {
      const response = await func.RefreshToken();
      console.log(response);
      
      if (response) {
        localStorage.setItem("accessToken", response);
      } else {
        logoutUser();
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      logoutUser();
    }
  };

  const logoutUser = () => {
    localStorage.clear();
    window.location.href = roleType;
  };

  const resetActivityTimer = useCallback(() => {
    isUserActiveRef.current = true;

    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }

    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false;
      logoutUser();
    }, logoutTime);
  }, [logoutTime]);

  useEffect(() => {
    if (isPublicPath) return;

    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = roleType;
      return;
    }

    const startRefreshCycle = () => {
      if (isUserActiveRef.current) {
        refreshToken();
        refreshTimeoutRef.current = setTimeout(startRefreshCycle, refreshInterval);
      }
    };

    refreshTimeoutRef.current = setTimeout(startRefreshCycle, refreshInterval);
    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false;
      logoutUser();
    }, logoutTime);

    window.addEventListener("click", resetActivityTimer);
    window.addEventListener("mousemove", resetActivityTimer);
    window.addEventListener("keypress", resetActivityTimer);

    return () => {
      if (activityTimeoutRef.current) clearTimeout(activityTimeoutRef.current);
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);

      window.removeEventListener("click", resetActivityTimer);
      window.removeEventListener("mousemove", resetActivityTimer);
      window.removeEventListener("keypress", resetActivityTimer);
    };
  }, [currentPath, resetActivityTimer, logoutTime, refreshInterval]);

  return null;
};

export default AuthManager;